// Central place for environment-driven configuration.
//
// The API base URL comes from REACT_APP_API_BASE_URL in .env, which Create
// React App inlines at build time. Change it there -- never in source -- and
// restart the dev server, since .env is only read at startup.

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error(
    "REACT_APP_API_BASE_URL is not set. Add it to .env and restart the dev server."
  );
}
